/** English strings. Arabic can be added later as a second resource bundle (RTL). */
const en = {
  common: {
    welcomeToBaharProcurementApp: "Welcome to Bahar One",
    loginPageFooterText: "Designed and developed by the IT team at BAHAR NGO",
    pendingApproval: "Pending approval",
    errorPageSubTitle: "Sorry, we couldn't find the page you are looking for",
    goBack: "Go back",
    retry: "Retry",
    user: "User",
    cancel: "Cancel",
    back: "Back",
    next: "Next",
  },
  login: {
    email: "Email",
    password: "Password",
    login: "Login",
    signup: "Signup",
    logOut: "Log out",
    switchAccount: "Switch account",
    actingAs: "Role",
    switchRole: "Switch role",
  },
  weekday: {
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },
  attendance: {
    title: "Attendance",
    subtitle: "Clock-ins and clock-outs from the office terminals, against the hours each day owes",
    filter: {
      any: "Any",
      facility: "Facility",
      // One picker covers centres, hospitals and warehouses as well as offices, and includes
      // everything underneath the one chosen — which no number of separate dropdowns could say.
      facilityHint: "Includes everything under it",
      team: "Team",
      country: "Country",
    },
    facilityType: {
      OFFICE: "Office",
      CENTER: "Centre",
      HOSPITAL: "Hospital",
      WAREHOUSE: "Warehouse",
    },
    searchPlaceholder: "Search by name or employee ID",
    date: "Date",
    employee: "Employee",
    code: "ID",
    status: "Status",
    anyStatus: "Any status",
    in: "In",
    out: "Out",
    inDevice: "Clocked in at",
    outDevice: "Clocked out at",
    counted: "Counted",
    countedHint: "Time inside 08:00-17:00. Work outside it is shown in the totals but does not count towards the hours owed.",
    owed: "Owed",
    owedHint: "The hours this day required. A weekend or a holiday owes nothing.",
    short: "Short",
    shortHint: "The gap between what the day owed and what was counted — an absence shows here in full.",
    flags: "Flags",
    department: "Department",
    governorate: "Governorate",
    officeCentre: "Office / Centre",
    late: "Late",
    early: "Left early",
    incomplete: "Incomplete",
    incompleteHint: "Only one punch that day - somebody came in and never clocked out, or the reverse.",
    // A day worked in part and taken as approved leave for the rest: it owes nothing.
    splitDay: "{{present}} present + {{leave}} {{kind}}",
    splitLegend: "Split — present for part of the day, approved leave for the rest",
    lateLegend: "Present, arrived late",
    emptyDay: "Nothing recorded",
    totalShort: "Total short",
    people: "People",
    exceptionsOnly: "Exceptions only",
    from: "From",
    to: "To",
    scope: {
      own: "Me",
      team: "My team",
      department: "My department",
      all: "Everyone",
    },
    statusValue: {
      PRESENT: "Present",
      ABSENT: "Absent",
      ON_LEAVE: "On leave",
      HOLIDAY: "Holiday",
      NON_WORKING_DAY: "Non-working day",
      // Not "present" and emphatically not "absent": nobody was measuring, because no terminal was
      // ever going to see them.
      WORKING_ELSEWHERE: "Working elsewhere",
    },
    chart: {
      monthly: "Hours, month by month",
      monthlyHint: "What was worked against what was owed. Both on one scale — they are the same hours.",
      arrival: "When they arrive",
      arrivalHint: "Average arrival by day of the week. Late is after {{time}}.",
      avgArrival: "Average arrival",
      breakdown: "What the period was made of",
      breakdownHint: "{{count}} days, by what each one turned out to be.",
    },
    person: {
      back: "Back to the report",
      openRecord: "Open employee record",
      exempt: "Never marked absent — board members work from wherever they are, so no terminal was ever going to see them.",
      notCollected: "Attendance is not collected for this person, so an empty period here is not an absence.",
      noDays: "Nothing has been recorded for this period.",
      days: "Every day",
      openFull: "Open the full attendance record",
      notVisible: "You may not view this person's attendance.",
      manager: "Reports to",
      team: "Team",
    },
    office: "Office",
    syncNow: "Collect now",
    syncAsked: "Asked the terminals server to collect \u2014 it runs within a minute or two",
    syncQueued: "Collection requested",
    teamOfOne:
      "Only your own record is in this view \u2014 nobody is recorded as reporting to you. Reporting lines come from the Microsoft directory; ask HR to set the manager on your people, then run Import from directory.",
    lastCollected: "Punches last collected {{when}}",
    neverCollected: "No collection has run yet",
    // "newest 37 min ago" beside "collected 4 min ago" reads as a 33-minute lag. It is not one:
    // people clock in and out twice a day, so the newest punch is normally older than the last
    // collection, and saying WHEN SOMEBODY LAST CLOCKED removes the arithmetic entirely.
    punchesHeld: "{{count}} punches held \u00b7 somebody last clocked {{newest}}",
    punchesHeldHint:
      "Punches arrive only when somebody clocks in or out, so the last one is usually older than the last collection. A gap here is a quiet corridor, not a delay.",
  },
  period: {
    week: "Week",
    month: "Month",
    custom: "Custom",
    from: "From",
    to: "To",
    previous: "Previous period",
    next: "Next period",
  },
  report: {
    title: "Attendance Report",
    subtitle: "A week or a month at a time, by person — as a list of totals or a calendar of days",
    workingDays: "Working days",
    worked: "Worked",
    owed: "Owed",
    people: "people",
    listView: "Show totals",
    calendarView: "Show calendar",
    pdf: "PDF",
    empty: "Nothing recorded for this period",
  },
  dashboard: {
    title: "Attendance & Leave",
    subtitle: "How the month is going, who is not in, and what is waiting on you",
    attendanceRate: "Attendance",
    people: "People",
    awayToday: "Away today",
    awaySoon: "Away in the next two weeks",
    nobodyAway: "Everyone is in today",
    nobodyAwaySoon: "Nobody is booked off",
    pending: "Pending",
    waitingOnYou: "Waiting for you",
    leaveRequests: "leave requests to decide",
    nothingWaiting: "Nothing waiting for you",
    myBalance: "My balance",
    noBalance: "No balance is kept for you",
    needsALook: "Worth a look",
    cleanMonth: "Nobody is behind on hours",
    openCalendar: "Calendar",
    openApprovals: "Approvals",
    openReport: "Report",
    throughTheMonth: "Attendance through the month",
    howDaysWent: "How the days went",
    backOn: "Back on",
  },
  leaveRecord: {
    title: "Leave record",
    subtitle: "Leave that was actually taken — approved, and over. The queue of what is still waiting is on the leave list.",
    year: "Year",
    anyType: "Any kind",
    onThisPage: "On this page",
    hours: "Time",
    fullDay: "Full day",
  },
  leaveCalendar: {
    title: "Leave Calendar",
    subtitle: "Who is away and when, so a clash is visible before it happens",
    anyKind: "Any kind",
    includePending: "Include pending",
    notOnLeave: "Not on leave",
    intensityLegend: "Paler — part of a day, stronger — more of it (a whole day is full colour)",
    pendingLegend: "Dashed outline — requested, not yet approved",
    dayView: "Day",
    weekView: "Week",
    monthView: "Month",
    yearView: "Year",
    timelineView: "Timeline",
    empty: "Nobody is away in this period",
  },
  leave: {
    // Column headings the record page shares with the list — one set of words for one thing.
    code: "Reference",
    type: "Kind",
    scopeLabel: "Whose",
    title: "Leave",
    subtitle: "Your leave, your balance, and anything waiting on you",
    request: "Request leave",
    submit: "Submit request",
    submitted: "Leave request submitted",
    searchPlaceholder: "Search by reference or name",
    step: { kind: "Kind", when: "When", review: "Review" },
    yourBalance: "Your balance",
    // The label over the figure, not a sentence about it: "Current leave credit" is what HR and
    // the staff handbook call it, and the balance line reads as a fact rather than an address.
    currentCredit: "Current leave credit",
    ofEntitlement: "of {{total}}",
    minutes: "Minutes",
    minimumHour: "Leave is taken in at least one hour",
      minimumHalfDay: "This kind of leave is taken in half days — half a day is the shortest.",
    legalBasis: "Leave here follows {{law}}.",
    chargeableDays_one: "1 working day charged",
    chargeableDays_other: "{{count}} working days charged",
    // A part of a day is said as the hours it is — "2 hours of 1 working day" — never as a fraction
    // of days, which reads as a whole day charged.
    chargeablePartial_one: "{{duration}} of 1 working day",
    chargeablePartial_other: "{{duration}} across {{count}} working days",
    overBalance: "{{over}} more than you have — it can still be submitted, and your approvers will see this",
    noApprovers: "Nobody can be asked to sign this yet",
    showDocument: "Preview document",
    hideDocument: "Hide document",
    kind: "Kind of leave",
    kindHint: "Each kind has its own rules",
    drawsOnAnnual: "Comes out of your annual leave",
    noBalance: "No balance is kept for this",
    needsDocument: "A document is required",
    needsDocumentAfter: "A document is required beyond {{days}} days",
    from: "First day",
    to: "Last day",
    partOfADay: "Part of a day",
    startingAt: "Starting at",
    endingAt: "Back at",
    endAfterStart: "Must be after the start",
    thatIs: "That is {{duration}}",
    hours: "Hours",
    accruedSoFar: "Earned so far",
    accruedByDate: "Earned by",
    officerInCharge: "Officer in charge while away",
    officerInChargeHint: "Who is answering for the post",
    officerInChargeRequired_one: "Required — one person reports to you and needs somebody to go to",
    officerInChargeRequired_other: "Required — {{count}} people report to you and need somebody to go to",
    reason: "Reason",
    reasonOptional: "Optional — anything the approver needs to know.",
    reasonCategory: "Reason for annual leave",
    reasonCategoryHelp: "Optional. Counted across the year; “Prefer not to say” is a real answer.",
    contactPhone: "Contact phone while away",
    contactPhoneHelp: "In case of emergency. Optional.",
    addressDuringLeave: "Address during the leave",
    addressDuringLeaveHelp: "Where you will be, if not at home. Optional.",
    itCosts: "Days charged",
    balanceAfter: "{{before}} left now, {{after}} after this",
    skipped_one: "1 day in this range costs nothing",
    skipped_other: "{{count}} days in this range cost nothing",
    skip: { WEEKEND: "weekend", HOLIDAY: "public holiday", NOT_SELECTED: "not one of the chosen days" },
    willBeSignedBy: "Will be signed by",
    approvalsFlow: "Approvals flow",
    willBeNotified: "Will be notified",
    notifiedWhen: "Once the request is fully approved.",
    requesterStep: "You (certifying the request)",
    supervisor: "Direct supervisor",
    hrResponsible: "HR responsible",
    hrSkipped: "The HR step does not apply to this request",
    warning: {
      NO_BALANCE: "You do not have enough leave left for all of this: {{unpaidDays}} day(s) from {{unpaidFrom}} go past your balance. Approved leave is paid, so your balance will go below zero. You can still submit it, and your approvers will see the same note.",
      PROBATION: "You have been here {{serviceMonths}} months, which is inside the {{probationMonths}}-month probation period. Your approvers will see this.",
      PAST_DATES: "This request is for time that has already passed.",
      EXCEEDS_MONTHLY_CAP: "{{month}} already has {{held}} day(s) of this, and the most allowed in one month is {{max}}.",
      SHORT_NOTICE: "Short notice: the policy asks for {{expected}} working day(s) ahead for {{days}} day(s) off, and this gives {{given}}. You can still submit it, and your approvers will see this.",
      OVERLAPS: "You already have leave at these times — another leave on the same day must not overlap its hours.",
      EXCEEDS_CONSECUTIVE: "This kind of leave cannot be taken for more than {{max}} days at a time, and this is {{days}}.",
      NO_CHARGEABLE_DAYS: "Every day in this range is a weekend or a public holiday, so there is nothing to request.",
      WRONG_GENDER: "This kind of leave is not available to you.",
      WRONG_RELIGION: "This kind of leave is not available to you.",
      ROLE_REQUIRED: "This kind of leave is only available to certain roles.",
      NOT_YET_EFFECTIVE: "This kind of leave starts after {{effectiveAfterMonths}} months of service, and you have {{serviceMonths}}.",
      PROBATION_NOT_ALLOWED: "No paid leave is taken during probation (Working Hours Policy). The leave accrued meanwhile is added to your balance once probation ends.",
      LATE_ANNUAL_REQUEST: "Too late to request: annual leave by the hour can be requested up to 24 hours after it ends, and a day of annual leave only until the end of that day. The deadline was {{deadline}}. Speak to HR if the time should still be recorded.",
      LATE_HOURLY_REQUEST: "This hourly leave is being asked for {{days}} days after it — the policy allows {{grace}}. It will be treated as unpaid.",
      SHORT_LEAVE_UNPAID: "A {{days}}-day request of this kind is unpaid under the policy (up to {{max}} days). Longer ones are paid with a medical report.",
      NOTICE_PERIOD_NOT_ALLOWED: "This kind of leave is not normally taken while working out notice. Your approvers will see this.",
      AFTER_LAST_WORKING_DAY: "Your separation has been agreed and your last working day is {{lastWorkingDay}} — leave cannot run past it.",
    },
    balances: "Balances",
    remaining: "Remaining",
    used: "Used",
    eligibleToday: "Eligible today",
    eligibleAccrued: "Accrued in full",
    untilContractEnd: "to",
    carriedOver: "Carried over",
    carryOverEnding: "ends",
    carryOverExpired: "expired",
    entitlement: "Entitlement",
    notTracked: "No balance kept",
    myRequests: "My requests",
    reference: "Reference",
    employee: "Employee",
    dates: "Dates",
    duration: "Duration",
    status: "Status",
    pendingWith: "With",
    thenWith: "then {{names}}",
    signedBy: "Signed by {{name}}",
    document: "Open as a document",
    cancelRequest: "Cancel",
    withdrawRequest: "Ask to withdraw",
    withdrawReason: "Why are you asking to withdraw this?",
    cancelled: "Request cancelled",
    withdrawAsked: "Withdrawal requested",
    anyStatus: "Any status",
    statusValue: {
      DRAFT: "Draft",
      PENDING: "Waiting",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      CANCELLED: "Cancelled",
      WITHDRAW_REQUESTED: "Withdrawal asked",
      WITHDRAWN: "Withdrawn",
    },
    scope: { own: "Mine", team: "My team", all: "Everyone" },
  },
};

export default en;
